import React from 'react'
import { navigationController } from 'components/Modal'

export type LeftSidebarProps = {
  leftSidebar: {
    set: (views: any[]) => void
    push: (component: React.ReactNode, options?: any) => void
    replace: (id: any, component: React.ReactNode, options?: any) => void
    pop: () => void
    close: () => void
    remove: (id: any) => void
  }
}

const withLeftSidebar = <WrappedProps extends object>(
  WrappedComponent: React.ComponentType<WrappedProps>
) => {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component'

  const WithLeftSidebar = React.forwardRef<typeof WrappedComponent, Omit<WrappedProps, keyof LeftSidebarProps>>((props, ref) => {
    const actions = navigationController.useActions()

    return (
      <WrappedComponent
        {...props as WrappedProps}
        ref={ref}
        leftSidebar={actions}
      />
    )
  })

  WithLeftSidebar.displayName = `withLeftSidebar(${displayName})`

  return WithLeftSidebar
}

export default withLeftSidebar
